import React from 'react';
import { Typography } from '@mui/material';
import { Button, Modal, ModalActions, ModalContent } from '@uplift/ui-v2';
import { useL10n } from '@uplift/hooks';
import { useStyles } from './modal.styles';
import { ROUTING_CONFIG } from '@uplift/constants';

type AllowDevicesModalProps = {
  isOpen: boolean;
  setIsOpen: (status: boolean) => void;
};

export const AllowDevicesModal: React.VFC<AllowDevicesModalProps> = ({ isOpen, setIsOpen }) => {
  const { classes } = useStyles();
  const l10n = useL10n();

  return (
    <Modal
      open={isOpen}
      onClose={() => setIsOpen(false)}
      title={l10n.sessions.allowDevices.title}
      disableBackdropClick
      disableEscapeKeyDown
      showCloseIcon={false}
    >
      <ModalContent>
        <Typography className={classes.text}>
          {l10n.sessions.allowDevices.line1}
        </Typography>
        <Typography>
          {l10n.sessions.allowDevices.line2}
        </Typography>
      </ModalContent>
      <ModalActions>
        <Button
          className={classes.button}
          variant="contained"
          color="secondary"
          fullWidth
          component="a"
          href={ROUTING_CONFIG.support}
          target="_blank"
          rel="noreferrer"
        >
          {l10n.sessions.allowDevices.readInstructions}
        </Button>
      </ModalActions>
    </Modal>
  );
};
